export default "__VITE_ASSET__429a4664__"